module.exports = __webpack_public_path__ + "img/faq-card.a2c86b7c.png";